import { render, staticRenderFns } from "./UpdateApiRole.vue?vue&type=template&id=099323fd&scoped=true"
import script from "./UpdateApiRole.vue?vue&type=script&lang=js"
export * from "./UpdateApiRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099323fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099323fd')) {
      api.createRecord('099323fd', component.options)
    } else {
      api.reload('099323fd', component.options)
    }
    module.hot.accept("./UpdateApiRole.vue?vue&type=template&id=099323fd&scoped=true", function () {
      api.rerender('099323fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/roleApi/UpdateApiRole.vue"
export default component.exports